import { TextInput } from '@mantine/core'

/**
 * The birth date field (profile `birthDate`): shared by `ProfileForm` and `AgeGate`'s ask-once modal so both read
 * the same way. Typed as an ISO date; the age check itself lives in shared/ (`isAdultJs`).
 */
export function BirthDateField(props: { value: string; onChange: (value: string) => void; today: string; error?: string; required?: boolean }) {
  return (
    <TextInput
      type="date"
      label="Birth date"
      value={props.value}
      max={props.today}
      required={props.required}
      onChange={(event) => props.onChange(event.currentTarget.value)}
      error={props.error}
    />
  )
}
